import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../utils/axiosInstance";

function OrderTracking() {

  const [orderId, setOrderId] = useState("");
  const [order, setOrder] = useState(null);
  const [searchParams] = useSearchParams();
  useEffect(() => {

    const id = searchParams.get("id");

    if (id) {

      setOrderId(id);

      api.get(`/api/orders/track/${id}`)
        .then(res => setOrder(res.data))
        .catch(() => {

          setOrder(null);

        });

    }

  }, [searchParams]);


  const trackOrder = async () => {

    try {

      const res = await api.get(`/api/orders/track/${orderId}`);
      setOrder(res.data);

    } catch (err) {

     setOrder(null);

     alert(
       "No order found with this ID"
     );

    }

  };

  const steps = [
    "PLACED",
    "CONFIRMED",
    "PACKED",
    "SHIPPED",
    "OUT_FOR_DELIVERY",
    "DELIVERED"
  ];

  return (

    <div className="min-h-screen bg-[#FDFCFB] p-10">

      <h1 className="text-4xl font-serif italic text-center mb-10 text-purple-700">
        Track Your Order
      </h1>

      {/* SEARCH */}

      <div className="flex justify-center gap-4 mb-10">

        <input
          type="text"
          placeholder="Enter Order ID (e.g. 123)"
          value={orderId}
          onChange={(e)=>setOrderId(e.target.value)}
          className="border p-3 rounded-xl w-64"
        />

        <button
          onClick={trackOrder}
          className="bg-purple-700 text-white px-6 py-3 rounded-full"
        >
          Track
        </button>

      </div>

      {/* TIMELINE */}

      {order && (

        <div className="max-w-xl mx-auto">
        <div className="bg-white shadow rounded-xl p-5 mb-6">

          <p>
            <b>Order ID:</b> #{order.id}
          </p>

          <p>
            <b>Status:</b> {order.status}
          </p>

          <p>
            <b>Courier:</b>{" "}
            {order.courierPartner || "-"}
          </p>

          <p>
            <b>Tracking Number:</b>{" "}
            {order.trackingNumber || "-"}
          </p>

          <p>
            <b>Expected Delivery:</b>{" "}
            {order.expectedDeliveryDate || "-"}
          </p>

          {
            order.deliveredDate && (
              <p>
                <b>Delivered On:</b>{" "}
                {order.deliveredDate}
              </p>
            )
          }

        </div>

          <div className="space-y-6">

            {steps.map((step,index)=>{

              const currentStep =
                steps.indexOf(order.status);

              const completed =
                currentStep >= index;

              return (

                <div
                  key={index}
                  className="flex items-center gap-4"
                >

                  <div
                    className={`w-6 h-6 rounded-full ${
                      completed
                        ? "bg-green-500"
                        : "bg-gray-300"
                    }`}
                  />

                  <p
                    className={`font-medium ${
                      completed
                        ? "text-green-700"
                        : "text-gray-400"
                    }`}
                  >
                    {step.replaceAll("_"," ")}
                  </p>

                </div>

              );

            })}

          </div>

        </div>

      )}

    </div>

  );

}

export default OrderTracking;